var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hello',{attrs:{"msg":"Выберите Гайд.","msg_warning":"Пожалуйста, используйте для проведения гайд-интервью уникальную ссылку, которую Вы получили в e-mail о назначении Вам кандидата."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }